import ApiService from "../service";

import { bucketsUrl } from "./api";

class BucketService extends ApiService {
  listUrl = bucketsUrl;
}

export default BucketService;
